import styled from 'styled-components';

import {
  Form,
  Button as SemanticButton,
  Image,
  Radio as SemanticRadio,
  Icon as SemanticIcon,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 100px;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  max-width: 570px;
  padding-bottom: 40px;
`;

const Text = styled(TextLayoutComponent)``;

const Header = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  margin-bottom: 5px;
`;

const HeaderQuestions = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 5px;
  margin-top: 40px;
`;

const SegmentTitle = styled(TextLayoutComponent.Bold)`
  margin-bottom: 5px;
`;

const TextError = styled(TextLayoutComponent)`
  font-size: 18px;
  margin: 10px 0;
  text-align: center;
`;

const ContainerNumberParticipants = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: ${(props) => props.marginBottom}px;
`;

const InputContainer = styled.div`
  flex: 1;
  margin-left: 20px;

  .ui.input {
    width: 100% !important;
  }
`;

const TrashIcon = styled(Image)`
  cursor: pointer;
  height: 20px;
`;

const QuestionSegment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    padding: 20px;
    flex: 2;
  }
`;

const SectionContainer = styled.div`
  margin-bottom: 20px;
`;

const HeaderSegmentContainer = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-right: 23px;
`;

const AnswersContainer = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 10px 0;
`;

const InputAnswerContainer = styled.div`
  flex: 1;
  width: 320px;
  display: flex;
`;

const QualifyContainer = styled.div`
  display: flex;
  margin: 0 20px;
  width: 120px;
`;

const IconCircle = styled(Image)`
  cursor: pointer;
  height: 20px;
  width: 20px;
`;

const CircleItem = styled.div`
  width: ${({ small }) => (small ? '25px' : '30px')};
  height: ${({ small }) => (small ? '25px' : '30px')};
  border-radius: 15px;
  display: flex;
  background-color: blue;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

const QuestionField = styled(Form.Field)`
  &&&&& {
    min-width: 100% !important;
    margin: 0px;
  }
`;

const ScreenerQuestionContainer = styled.div`
  margin: 10px 0;
`;

const AddScreenerQuestion = styled.a`
  cursor: pointer;
  margin-top: 10px;
`;

const AddQuestion = styled.text`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 40px;
`;

const NextButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 125px;
  }
`;

const BackButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-right: 60px;
    width: 125px;
  }
`;

const SetUpContainer = styled.div`
  ${({ marginTop }) => marginTop && `
    margin-top: 14px;
  `}
`;

const Radio = styled(SemanticRadio)`
  margin-right: 5px;
  &&&& > label {
    cursor: ${({ notalowedcursor }) => (notalowedcursor ? 'not-allowed' : 'pointer')};
  }
`;

const Icon = styled(SemanticIcon)`
  cursor: pointer;
  &&&{
    ${({ small }) => small && 'font-size: 12px;'};
    margin: 0;
    height: fit-content;
    width: fit-content;
    color: ${(props) => props.theme.color.white};
  }
`;

const ActionLink = styled.a`
  float: right;
  margin-right: 25px;
`;

const ActionButton = styled.button`
  float: right;
  color: #477ae9;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    color: #1954d3;
  }

  &:disabled {
    cursor: not-allowed;
    color: #c4c4c4;
  }
`;

const ActionContainer = styled.div`
  display: flex;
  margin-left: auto; 
  margin-right: 10px;
  gap: 15px;
`;

const calculateRatingColor = (percentage) => {
  const numericPercentage = parseInt(percentage, 10);
  if (numericPercentage >= 80) {
    return '#D6FFC1';
  }

  if (numericPercentage >= 41) {
    return '#FFFDC4';
  }

  if (!numericPercentage) {
    return '#F4F4F4';
  }

  return '#FFCDCD';
};

export const ColoredQuestionRating = styled(TextLayoutComponent)`
  position: absolute;
  top: 0;
  right: -250px;
  background-color: ${(props) => calculateRatingColor(props.percentage)};
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
`;

export const QuestionOptionPercentage = styled(TextLayoutComponent)`
  position: absolute;
  top: 50%;
  right: -100px;
  transform: translateY(-50%);
  background-color: #F0F0F0;
  color: #4D5473;
  border-radius: 5px;
  margin-bottom: 2px !important;
  margin-left: 10px;
  width: auto;
  padding: 0px 8px;
`;

export const Modal = styled(SemanticModal)`
  &&& {
    width: fit-content;
    max-width: 470px;
    padding: 40px;
    border-radius: 1px;
  }

  p {
    white-space: pre-wrap;
  }
`;

export const ModalActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const Button = styled(SemanticButton).attrs((props) => {
  const color = props.color || '#FFFFFF';
  const backgroundColor = props.backgroundColor || '#477AE9';
  return {
    color,
    backgroundColor,
  };
})`
  &&&:hover {
    color: ${(props) => props.color};
    background-color: ${(props) => props.backgroundColor};
  }
  &&& {
    text-align: center;
    color: ${(props) => props.color};
    background-color: ${(props) => props.backgroundColor};
    font: "Roboto Medium";
    font-size: 15px;
    font-weight: 500;
    margin: 4px;
    min-width: 80px;
    text-align: center;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  }
`;

export const FieldQuestionRate = styled(TextLayoutComponent)`
  background-color: #F4F4F4;
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px 7px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 12px;
`;

export {
  AddQuestion,
  AddScreenerQuestion,
  AnswersContainer,
  BackButton,
  ButtonContainer,
  ContainerNumberParticipants,
  Header,
  HeaderQuestions,
  HeaderSegmentContainer,
  IconCircle,
  InputAnswerContainer,
  InputContainer,
  NextButton,
  QualifyContainer,
  QuestionField,
  QuestionSegment,
  ScreenerQuestionContainer,
  SectionContainer,
  SegmentTitle,
  Text,
  TextError,
  TrashIcon,
  SetUpContainer,
  Radio,
  CircleItem,
  Icon,
  ActionLink,
  ActionButton,
  ActionContainer,
};
